import { FunctionComponent } from 'react';
import styled from 'styled-components';

import LinkTag from '@/components/common/LinkTag';
import { ROUTES } from '@/types/common';
import { RelatedQnaVo } from '@/types/qna';

import RelatedQuestionItem, { RelatedQuestionItemProps } from './RelatedQuestionItem';

interface QnaRelatedQuestionProps extends Omit<RelatedQuestionItemProps, 'questionCard'> {
  categoryName?: string;
  relatedQna?: RelatedQnaVo[];
  onClickRelatedQna: (questionPid: string) => void;
}

const QnaRelatedQuestion: FunctionComponent<QnaRelatedQuestionProps> = ({
  categoryName,
  relatedQna,
  onClickRelatedQna,
}) => {
  if (!relatedQna?.length) return <></>;
  return (
    <Wrapper>
      <Title>{categoryName} 관련 질문</Title>
      <ul>
        {relatedQna.map((questionCard, i) => (
          <LinkTag
            key={`related_qna_${questionCard.question.questionPid}`}
            onClickNavigateToScreen={() => {
              onClickRelatedQna(questionCard.question.questionPid);
            }}
            href={`${ROUTES.QNA.DETAIL.path}/${questionCard.question.questionPid}`}
          >
            <RelatedQuestionItem
              questionCard={questionCard}
              isLast={i === relatedQna.length - 1}
              onClickRelatedQna={() => onClickRelatedQna(questionCard.question.questionPid)}
            />
          </LinkTag>
        ))}
      </ul>
    </Wrapper>
  );
};

export default QnaRelatedQuestion;

const Wrapper = styled.div`
  margin-top: 24px;

  ${({ theme }) => `
    background: ${theme.color.white};
  `};
`;

const Title = styled.h1`
  padding: 8px 24px;

  ${({ theme }) => `
    ${theme.typography.UI19SB};
    color: ${theme.color.gray700};
  `};
`;
